import { render, staticRenderFns } from "./DashboardTvMarketing.vue?vue&type=template&id=782db882"
import script from "./DashboardTvMarketing.vue?vue&type=script&lang=ts"
export * from "./DashboardTvMarketing.vue?vue&type=script&lang=ts"
import style0 from "./DashboardTvMarketing.vue?vue&type=style&index=0&id=782db882&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports